import React, { FC } from 'react';
import { Field } from 'react-final-form';
import { RadioCardWrapper } from 'components/forms';
import styles from './Form.module.scss';

export const formFields = [
  {
    label: 'form.field.typeapi.calendar.label',
    description: 'form.field.typeapi.calendar.description',
    name: 'type_api',
    value: 'calendar',
  },
  {
    label: 'form.field.typeapi.contacts.label',
    description: 'form.field.typeapi.contacts.description',
    name: 'type_api',
    value: 'contacts',
  },
];

const ServiceApi: FC = () => (
  <div className={styles.fieldsContainer}>
    {formFields.map((field: any) => (
      <Field {...field} type='radio' component={RadioCardWrapper} key={field.value} />
    ))}
  </div>
);

export default ServiceApi;
